import React, { Component } from 'react';
import { connect } from 'react-redux';
import authUtils from '../../auth/utils';
import { withTranslation } from 'react-i18next';
import { loadKindergartenAttendances, loadKindergartenPayments, updateKindergartenPaymentDetail, createKindergartenPaymentDetail, updateKindergartenPayment } from './actions';
import utils from '../../common/services/utils';
import { fetchWeeklyProgram } from '../weeklyPrograms/actions';
import AttendanceTable from './Table';
import { Panel, FormControl, Row, Col } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import queryString from 'query-string';
import EditDialog from './Dialog';
import PaymentSettingsForm from './SettingsForm';
import ui from '../../common/services/ui';
import moment from 'moment';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faList } from '@fortawesome/free-solid-svg-icons';

class ManageKindergartenAttendance extends Component {

	constructor(props) {
		super(props);
		this.handleEditPaymentDetail = this.handleEditPaymentDetail.bind(this);
		this.handleHideEditDialog = this.handleHideEditDialog.bind(this);
		this.createPaymentDetail = this.createPaymentDetail.bind(this);
		this.updatePaymentDetail = this.updatePaymentDetail.bind(this);
		this.createPaymentAndPaymentDetail = this.createPaymentAndPaymentDetail.bind(this);
		this.handleSucces = this.handleSucces.bind(this);
		this.handlePaymentSubmit = this.handlePaymentSubmit.bind(this);
		this.handleMonthChange = this.handleMonthChange.bind(this);
		this.state = { showEdit: false, month: utils.getCurrentMonth() };
	}

	componentDidMount() {
		this.loadInitialData();
	}

	loadInitialData() {
		const { fetchWeeklyProgram, weeklyProgramItemId } = this.props;
		fetchWeeklyProgram(weeklyProgramItemId);
		this.loadData();
	}

	loadData(forMonth) {
		const { weeklyProgramItemId, loadKindergartenAttendances, loadKindergartenPayments } = this.props;
		const month = forMonth ? forMonth : this.state.month;
		loadKindergartenAttendances({ weeklyProgramItemId, month });
		// Note: There is only one master payment record for weekly program item and month
		loadKindergartenPayments({ weeklyProgramItemId, month });
	}

	handleEditPaymentDetail(attendance) {
		const { kindergartenPaymentDetails } = this.props;
		const { lessonDate, kindergartenPaymentDetail } = attendance;

		this.updateState({
			showEdit: true,
			lessonDate,
			kindergartenPaymentDetail: kindergartenPaymentDetails[kindergartenPaymentDetail]
		});
	}

	updateState(newState) {
		const currentState = this.state;
		this.setState({ ...currentState, ...newState });
	}

	handleHideEditDialog() {
		this.updateState({ showEdit: false });
	}

	createPaymentDetail(values) {
		const { createKindergartenPaymentDetail } = this.props;
		createKindergartenPaymentDetail(values, () => this.handleSucces());
	}

	updatePaymentDetail(id, values) {
		const { updateKindergartenPaymentDetail } = this.props;
		updateKindergartenPaymentDetail(id, values, () => this.handleSucces());
	}

	createPaymentAndPaymentDetail(values) {
		const { month } = this.state;
		const { lessonDate } = values;
		const { weeklyProgramItemId, createKindergartenPaymentDetail } = this.props;
		createKindergartenPaymentDetail({ ...values, weeklyProgramItemId, month, year: moment(lessonDate).year() }, () => this.handleSucces());
	}

	handleSucces() {
		this.loadData();
		this.handleHideEditDialog();
	}

	handlePaymentSubmit(values) {
		const { updateKindergartenPayment } = this.props;
		const kindergartenPayment = this.extractKindergartenPayment();
		updateKindergartenPayment(kindergartenPayment[0].id, { ...kindergartenPayment[0], ...values });
	}

	handleMonthChange(event) {
		this.loadData(event.target.value);
		this.updateState({ month: event.target.value });
	}

	extractKindergartenAttendances() {
		const { kindergartenAttendances, weeklyProgramItemId } = this.props;
		const { month } = this.state;
		return kindergartenAttendances[`${weeklyProgramItemId}.${month}`];
	}

	extractKindergartenPayment() {
		const { kindergartenPayments, weeklyProgramItemId } = this.props;
		const { month } = this.state;
		return Object.keys(kindergartenPayments)
			.map(id => kindergartenPayments[id])
			.filter(p => p.weeklyProgramItemId == weeklyProgramItemId && p.month == month)
	}

	renderPanelHeader(resource) {
		const { t } = this.props;
		const text = t(resource);
		const icon = <FontAwesomeIcon icon={faList} />;
		return [icon, text];
	}

	render() {
		const { kindergartenPaymentDetails, t, isReadonly, months, weeklyProgram } = this.props;
		const { showEdit, lessonDate, kindergartenPaymentDetail, month } = this.state;
		const kindergartenAttendances = this.extractKindergartenAttendances();
		const kindergartenPayment = this.extractKindergartenPayment();
		const events = {
			createPaymentDetail: this.createPaymentDetail,
			updatePaymentDetail: this.updatePaymentDetail,
			createPaymentAndPaymentDetail: this.createPaymentAndPaymentDetail
		};
		const startTime = ui.formatTime(utils.parseTime())

		return (
			<div>
				<Link to='/kindergartenAttendance' className='btn btn-default mb-1'>{t('Common_BackToList')}</Link>
				<Panel>
					<Panel.Body>
						<Row>
							<Col sm={8}>
								{weeklyProgram &&
									<h4>
										{
											`${weeklyProgram.name || weeklyProgram.grade.name} /
										 ${t(ui.days[weeklyProgram.weekday])} / 
										 ${ui.formatTime(utils.parseTime(weeklyProgram.startTime))} - ${ui.formatTime(utils.parseTime(weeklyProgram.endTime))}`
										}
									</h4>
								}
							</Col>
							<Col sm={2} smOffset={2}>
								<FormControl componentClass='select' placeholder='select' value={month} onChange={this.handleMonthChange}>
									{ui.makeOptionValues(months)}
								</FormControl>
							</Col>
						</Row>
					</Panel.Body>
				</Panel>
				<Panel>
					<Panel.Heading>{this.renderPanelHeader('KindergartenAttendance_WeeklyPayments')}</Panel.Heading>
					<Panel.Body>
						<AttendanceTable
							kindergartenAttendances={kindergartenAttendances}
							kindergartenPaymentDetails={kindergartenPaymentDetails}
							t={t}
							onEditPaymentDetail={this.handleEditPaymentDetail}
							isReadonly={isReadonly}
						/>
					</Panel.Body>
				</Panel>
				{
					kindergartenPayment.length > 0 &&
					(
						<Panel>
							<Panel.Heading>{this.renderPanelHeader('KindergartenAttendance_MonthlyPaymentSummary')}</Panel.Heading>
							<Panel.Body>
								<PaymentSettingsForm
									initialValues={kindergartenPayment[0]}
									onSubmit={this.handlePaymentSubmit}
									isReadonly={isReadonly}
								/>
							</Panel.Body>
						</Panel>
					)
				}
				<EditDialog
					show={showEdit}
					t={t}
					onHide={this.handleHideEditDialog}
					lessonDate={lessonDate}
					kindergartenPaymentDetail={kindergartenPaymentDetail}
					kindergartenPayment={kindergartenPayment}
					isReadonly={isReadonly}
					events={events}
				/>
			</div>
		);
	}
}

const mapStateToProps = (state, ownProps) => {
	const { weeklyProgramItemId } = queryString.parse(ownProps.location.search);

	const {
		entities: { kindergartenAttendances, kindergartenPaymentDetails, kindergartenPayments, weeklyPrograms },
		auth: { currentUser },
		lookups: { months }
	} = state;

	return {
		weeklyProgramItemId,
		weeklyProgram: weeklyPrograms[weeklyProgramItemId],
		kindergartenAttendances,
		kindergartenPaymentDetails,
		kindergartenPayments,
		months,
		isReadonly: authUtils.hasReadOnlyPermission(currentUser, 'KindergartenAttendance')
	};
};

const mapDispatchToProps = {
	loadKindergartenAttendances,
	loadKindergartenPayments,
	updateKindergartenPaymentDetail,
	updateKindergartenPayment,
	createKindergartenPaymentDetail,
	fetchWeeklyProgram
}

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(ManageKindergartenAttendance));